import {
  ACCOUNT_OTP_GET_TYPE,
  CONFIRM_DEBT_SHOW_MODAL,
  GLOBAL_ACCOUNT_LIST,
  GLOBAL_DOMAIN_USERINFO,
  GLOBAL_SELECT_ACCOUNT,
  GLOBAL_USERINFO,
  ROUTER_RESET,
  SOCKET_AUTHENTICATED,
  WATCHLIST_SERVER_GET_LIST,
} from 'redux/actions';
import {
  IAccount,
  IAction,
  IAuthToken,
  IBrokerSubAccountRes,
  IRequest,
  IResponse,
  ISocket,
  IUserInfo,
} from 'interfaces/common';
import {
  IBankInfoForKisResponse,
  IEquityConfirmDebtResponse,
  IParamsEquityConfirmDebt,
} from 'interfaces/api';
import { IBrokerSubAccount } from 'interfaces/actions';
import { IState } from 'redux/global-reducers';
import { SystemType } from 'constants/enum';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getAccounts, getBrokerAccounts } from 'utils/domain';
import { getKey, setKey } from 'utils/localStorage';
import { query } from 'utils/socketApi';
import config from 'config';

const queryEquityBrokerSubAccount = (request: IBrokerSubAccount) => {
  return query(config.apis.brokerEquitySubAccount, request);
};
const queryDerBrokerSubAccount = (request: IBrokerSubAccount) => {
  return query(config.apis.brokerDerSubAccount, request);
};

function* getAccountBankInfo(accounts: IAccount[]) {
  const response: IAccount[] = yield all(
    yield accounts.map((val) => {
      let responseBankInfo;
      if (val.type === SystemType.DERIVATIVES) {
        responseBankInfo = query(config.apis.derivativesBankInfoForKis, {
          accountNo: val.accountNumber,
        });
      } else {
        responseBankInfo = query(config.apis.equityBankInfoForKis, {
          accountNo: val.accountNumber,
        });
      }
      return responseBankInfo
        .then((resp: IResponse<IBankInfoForKisResponse[]>) => {
          const bankIICA = resp.data.find((bank) => bank.isDefault);
          return {
            ...val,
            isIICA: bankIICA?.isDefault,
            bankIICAId: bankIICA?.bankID,
          };
        })
        .catch(() => val);
    })
  );
  return response;
}

function* getBrokerSubAccount(
  params: IBrokerSubAccount,
  isDerivatives: boolean = false
) {
  let response: IBrokerSubAccount[];
  try {
    if (!isDerivatives) {
      response = yield call(queryEquityBrokerSubAccount, params);
    } else {
      response = yield call(queryDerBrokerSubAccount, params);
    }
    return response;
  } catch (error) {
    console.log('error', error);
    return [];
  }
}
const queryConfirmDebt = (params: IParamsEquityConfirmDebt) => {
  return query(config.apis.equityConfirmDebtAll, params);
};

export function* doAuthenticateSocket(request: IRequest<ISocket>) {
  try {
    const socket = request.payload;

    const domainUserInfo = socket.authToken;

    if (socket.authToken?.userInfo) {
      setKey('userInfo', socket.authToken.userInfo);
    }

    let userInfo;

    if (!socket.authToken?.userInfo) {
      userInfo = getKey('userInfo');
    }

    const username =
      socket.authToken?.userInfo?.username || (userInfo as any).username;

    const accountList =
      socket.authToken?.userInfo?.accounts || (userInfo as any).accounts;

    const isBroker = socket.authToken?.userInfo?.userLevel === 'BROKER';

    const store: IState = yield select((state: IState) => ({
      selectedAccount: state.selectedAccount,
      lang: state.lang,
    }));

    if (!isBroker) {
      yield put({
        type: WATCHLIST_SERVER_GET_LIST,
      });

      yield put({
        type: ACCOUNT_OTP_GET_TYPE,
      });

      if (domainUserInfo != null) {
        yield put<IAction<IAuthToken>>({
          type: GLOBAL_DOMAIN_USERINFO,
          payload: domainUserInfo,
        });

        yield put<IAction<IUserInfo>>({
          type: GLOBAL_USERINFO,
          payload: domainUserInfo.userInfo || userInfo,
        });
      }
      if (accountList != null && accountList.length > 0) {
        const accounts = getAccounts(username, accountList);

        yield put<IAction<IAccount[]>>({
          type: GLOBAL_ACCOUNT_LIST,
          payload: accounts,
        });

        if (
          store.selectedAccount == null ||
          store.selectedAccount.username !== username
        ) {
          yield put<IAction<IAccount>>({
            type: GLOBAL_SELECT_ACCOUNT,
            payload: accounts[0],
          });
        }
        if (
          config.loanQueryAll &&
          ((store.selectedAccount != null &&
            store.selectedAccount.type === SystemType.EQUITY) ||
            accounts[0].type === SystemType.EQUITY)
        ) {
          try {
            const response: {
              data: IEquityConfirmDebtResponse[];
            } = yield call(queryConfirmDebt, {
              accountNumber:
                store.selectedAccount?.account || accounts[0].account,
              historyBy: new Date().getMonth(),
              signed: false,
            });
            if (response.data.length > 0) {
              yield put({
                type: CONFIRM_DEBT_SHOW_MODAL,
              });
            }
          } catch (error) {
            console.log({ error });
          }
        }
       

        const accountsBankData: IAccount[] = yield getAccountBankInfo(accounts);
        if (accountsBankData.some((val) => val.isIICA)) {
          yield put<IAction<IAccount[]>>({
            type: GLOBAL_ACCOUNT_LIST,
            payload: accountsBankData,
          });

          if (
            accountsBankData[0].isIICA &&
            (store.selectedAccount == null ||
              store.selectedAccount.username !== username)
          ) {
            yield put<IAction<IAccount>>({
              type: GLOBAL_SELECT_ACCOUNT,
              payload: accountsBankData[0],
            });
          }
        }
      }
    } else {
      const brokerDerAccounts: {
        data: IBrokerSubAccountRes[];
      } = yield getBrokerSubAccount({ language: store.lang }, true);
      const brokerEquityAccounts: {
        data: IBrokerSubAccountRes[];
      } = yield getBrokerSubAccount({ language: store.lang }, false);

      const brokerAccounts = getBrokerAccounts(username, [
        ...brokerDerAccounts.data,
        ...brokerEquityAccounts.data,
      ]);

      yield put<IAction<IAccount[]>>({
        type: GLOBAL_ACCOUNT_LIST,
        payload: brokerAccounts,
      });

      if (
        store.selectedAccount == null ||
        store.selectedAccount.username !== username
      ) {
        yield put<IAction<IAccount>>({
          type: GLOBAL_SELECT_ACCOUNT,
          payload: brokerAccounts[0],
        });
      }
    }
    yield put({
      type: WATCHLIST_SERVER_GET_LIST,
    });

    yield put({
      type: ROUTER_RESET,
    });
  } catch (error) {
    console.error('Authenticate Socket ', error);
  }
}

export default function* watchAuthenticateSocket() {
  yield takeLatest(SOCKET_AUTHENTICATED, doAuthenticateSocket);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Socket/AuthenticateSocket.ts